import Link from "next/link";
import { useEffect, useState } from "react";

import CountryFlag from "../../shared/country-flag";
import CountrySelectorModal from "../modal/country-selector-modal";

import countryDD from "../../assets/stylesheets/core/dropdown/countryDropdown.module.scss";

interface CountryProps {
  name: string;
  iso: string;
  id: number;
}

interface CountrySelectorProps {
  className: string;
  selectedCountry: CountryProps;
  onClick: () => void;
  countries: CountryProps[];
  onSelectCountry: () => void;
  type: string;
}

const CountrySelector = (props: CountrySelectorProps) => {
  const { className, onClick, selectedCountry: defaultCountry, countries, onSelectCountry, type } = props;
  const [isOpen, setIsOpen] = useState(false);
  const [ selectedCountry, setSelectedCountry ] = useState(defaultCountry);

  const toggleModal = () => {
    setIsOpen((prevState => !prevState))
  }

  const submitModal = () => {
    onSelectCountry(selectedCountry);
    toggleModal();
  }

  //for case when user selects a country in modal but closes it without submitting.
  useEffect(() => {
    if(defaultCountry){
      setSelectedCountry(defaultCountry)
    }
  }, [isOpen])

  const submitDisabled = defaultCountry.iso === selectedCountry.iso;

  return <>
    <div
      className={'d-inline-flex nav-border-divider mobile-country-selector'}
      onClick={() => {
        setIsOpen(true);
        onClick?.();
      }}
    >
      <div className="icon-location align-middle d-inline-flex" />{" "}
      <div className={`${countryDD.countryDropdown}`}>
        <CountryFlag country={defaultCountry} className="img-flag mr-3" type={type}/>
        <div className={`${countryDD.countryName}`}>
          {defaultCountry?.iso}
        </div>
          <span className={`${countryDD.changeText} d-lg-none ml-auto text-uppercase text-underline font-weight-bold`}>Change</span>
         <i className='icon-chevron-down ml-1' />
      </div>
    </div>
    <CountrySelectorModal
      open={isOpen}
      closeModal={() => setIsOpen(false)}
      countries={countries}
      selectedCountry={selectedCountry}
      onClickSubmit={submitModal}
      setSelectedCountry={setSelectedCountry}
      type={type}
      submitDisabled={submitDisabled}
    />
  </>
}

export default CountrySelector;
